class AccordionGroup extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }

  handleClick(event) {
    if (!(event.target instanceof Element)) return;

    const summary = event.target.closest('summary');
    if (!summary) return;

    const details = summary.parentElement;

    if (
      !details ||
      details.tagName !== 'DETAILS' ||
      details.parentElement !== this
    ) {
      return;
    }

    event.preventDefault();

    if (details.open) {
      this.closeAccordion(details);
      return;
    }

    if (this.hasAttribute('single')) {
      this.querySelectorAll(':scope > details[open]').forEach((openDetails) => {
        if (openDetails !== details) {
          this.closeAccordion(openDetails);
        }
      });
    }

    this.openAccordion(details);
  }

  openAccordion(details) {
    const startHeight = details.offsetHeight;

    details.open = true;

    const borderHeight = details.offsetHeight - details.clientHeight;
    const endHeight = details.scrollHeight + borderHeight;

    this.animateAccordion(details, startHeight, endHeight, true);
  }

  closeAccordion(details) {
    const summary = details.querySelector(':scope > summary');
    if (!summary) return;

    const startHeight = details.offsetHeight;
    const borderHeight = details.offsetHeight - details.clientHeight;
    const endHeight = summary.offsetHeight + borderHeight;

    this.animateAccordion(details, startHeight, endHeight, false);
  }

  animateAccordion(details, startHeight, endHeight, keepOpen) {
    if (details.accordionAnimation) {
      details.accordionAnimation.cancel();
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      details.open = keepOpen;
      details.style.height = '';
      details.style.overflow = '';
      return;
    }

    details.style.overflow = 'hidden';
    details.style.height = `${startHeight}px`;

    const animation = details.animate(
      {
        height: [`${startHeight}px`, `${endHeight}px`]
      },
      {
        duration: 350,
        easing: 'cubic-bezier(0.4, 0, 0.2, 1)'
      }
    );

    details.accordionAnimation = animation;

    animation.onfinish = () => {
      if (details.accordionAnimation !== animation) return;

      details.open = keepOpen;
      details.style.height = '';
      details.style.overflow = '';
      details.accordionAnimation = null;
    };
  }
}

if (!customElements.get('accordion-group')) {
  customElements.define('accordion-group', AccordionGroup);
}